import { type FC } from 'react';
import { useUser } from '../../../../hooks/useUser';
import clsx from 'clsx';

interface Props {
  sidebarOpen: boolean
}

const SidebarUser: FC<Props> = ({ sidebarOpen }) => {
  const { user } = useUser();

  return (
    <div className={clsx(
      "relative mx-3 mb-6 transition-all duration-300 group",
      sidebarOpen ? "p-[1px] rounded-2xl bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500" : "bg-transparent"
    )}>
      <div className={clsx(
        "flex items-center gap-3 rounded-2xl transition-all duration-300 h-full",
        sidebarOpen ? "bg-white dark:bg-[#1a1f2e] p-3" : "justify-center p-0 bg-transparent"
      )}>
        <div className="relative flex-shrink-0">
          {/* Avatar Ring */}
          <div className={clsx(
            "absolute inset-0 rounded-full blur-[2px] opacity-70 transition-opacity duration-300",
            sidebarOpen ? "bg-indigo-500/20" : "bg-gradient-to-tr from-indigo-500 to-purple-500"
          )}></div>

          <div className={clsx(
            "relative rounded-full bg-white dark:bg-[#1a1f2e] flex items-center justify-center overflow-hidden border-2 transition-all duration-300",
            sidebarOpen ? "w-12 h-12 border-transparent" : "w-10 h-10 border-transparent p-[2px]"
          )}>
            {user?.avatar
              ? (
                <img src={user.avatar} alt="User" className="w-full h-full rounded-full object-cover" />
              )
              : (
                <span className="font-bold text-indigo-600 dark:text-indigo-400 text-sm">
                  {user?.name?.[0]}{user?.name?.[1]}
                </span>
              )}
          </div>

          {/* Online Status Dot */}
          <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white dark:border-[#1a1f2e] rounded-full"></div>
        </div>

        <div className={clsx(
          "flex flex-col overflow-hidden transition-all duration-300",
          sidebarOpen ? "w-auto opacity-100" : "w-0 opacity-0"
        )}>
          <p className="text-sm font-bold text-gray-900 dark:text-white whitespace-nowrap truncate max-w-[140px]">
            {user?.name}
          </p>
          <div className="flex items-center gap-1">
            <span className="w-1.5 h-1.5 rounded-full bg-indigo-500"></span>
            <p className="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap truncate max-w-[130px]">
              {user?.role?.name || 'Estudiante'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export { SidebarUser };
